import React from 'react'
import styledComponents from 'styled-components'

const AlertModal = ({ title, content, onClose }) => (
  <Layout>
    <div className="card">
      <header className="card-header">
        <p className="card-header-title">{title}</p>
        <a className="card-header-icon" aria-label="more options">
          <span className="icon">
            <i className="fas fa-angle-down" aria-hidden="true" />
          </span>
        </a>
      </header>
      <div className="card-content">
        <div className="content">{content}</div>
      </div>
      <footer className="card-footer">
        <a className="card-footer-item" onClick={onClose}>
          กลับ
        </a>
      </footer>
    </div>
  </Layout>
)

export default AlertModal

const Layout = styledComponents.div`
  max-width: 450px;
  min-width: 200px;
`



// WEBPACK FOOTER //
// ./src/modules/modal/AlertModal.js